import { getLoginEndpoint } from 'services/browser/SubdomainEndpoint'
import firebase from "firebase/app";
import { getCsrfTokenCookie, setNewCsrfTokenCookie } from 'services/browser/BrowserCookie'
import superagent from 'superagent'

export async function loginAtSubdomain(user: firebase.User) {
    try {
        const idToken = await user.getIdToken()
        setNewCsrfTokenCookie()
        const csrfToken = getCsrfTokenCookie()
        await superagent.post(getLoginEndpoint()).send({ csrfToken, idToken }).withCredentials()
    } catch(e) {
        return;
    }

}